<template lang="pug">
v-layout(align-start)
      v-flex
        v-data-table.elevation-1(:headers='headers' item-key='cxc' :items='cxc' :search='search' sort-by='codigo' :loading='loading' loading-text='Cargando, por favor espere...')
          template(v-slot:top)
            v-toolbar(flat color='primary' dark)
              v-toolbar-title Estados de Cuentas
              v-divider.mx-4(inset vertical)
              v-spacer
              v-text-field.text-xs-center(v-model='search' label='Búsqueda' single-line hide-details color='success')
              v-spacer
              v-dialog(v-model='dialog', persistent='', max-width='40%')
                template(v-slot:activator='{ on }')
                  v-btn(@click='exportPDF2()' small color='error')
                    v-icon(dark) mdi-pdf-box
              CuentaXCobrarM(:dialog='dialog' :editedIndex='editedIndex' @close='close' :read='read' :FormPadre='form' @save='listarCuentasXCobrar' @edited='listarCuentasXCobrar')
          template(v-slot:item.action='{ item }')
            v-tooltip(bottom='')
              template(v-slot:activator='{ on }')
                v-icon.mr-2(v-if="item.estatusPago === 'Pendiente'"  color='success' @click='editItem(item)' v-on="on") mdi-cash-usd
              | Cobrar
          template(v-slot:no-data='')
            h1 No hay Cuentas por Cobrar Asociadas
</template>

<script>
import Api from '@/services/methods'
import CuentaXCobrarM from '../../components/modals/CuentaXCobrarM'

import Jspdf from 'jspdf'
import JspdfAutotable from 'jspdf-autotable'

export default {
  name: 'pdf',

  data: () => ({
    dialog: false,
    read: false,
    loading: true,
    headers: [
      { text: 'Número Factura', align: 'left', sortable: false, value: 'idVenta.numFactura' },
      { text: 'Cliente', value: 'idCliente.nombre' },
      { text: 'Rif Cliente', value: 'idCliente.rif' },
      { text: 'Fecha Vencimiento', value: 'fechaVencimiento' },
      { text: 'Días Deuda', value: 'moroso' },
      { text: 'Debito', value: 'debito' },
      { text: 'Credito', value: 'credito' },
      { text: 'Tipo de Venta', value: 'tipoVenta' },
      { text: 'Concepto', value: 'idConcepto.nombre' },
      { text: 'Estatus', value: 'estatusPago' },
      { text: 'Acciones', value: 'action', align: 'right', sortable: false }
    ],
    search: '',
    cxc: [],
    clientes: [],
    permisosRuta: {},
    editedIndex: -1,
    estatus: [{ value: false, text: 'No' }, { value: true, text: 'Si' }],
    form: {},
    defaultItem: {}
  }),

  components: {
    CuentaXCobrarM,
    JspdfAutotable
  },
  computed: {
  },
  watch: {
    dialog (val) {
      val || this.close()
    }
  },
  created () {
    this.initialize()
    // this.permisosRuta = this.$store.state.empresa[0].permisos.find(permiso => permiso.ruta == "Almacen")
  },
  methods: {
    exportPDF2 () {
      var today = new Date()
      var date = today.getDate() + '-' + (today.getMonth() + 1) + '-' + today.getFullYear()

      var columns = [
        { title: 'N° Factura', dataKey: 'numF' },
        { title: 'Fecha Registro', dataKey: 'fechaR' },
        { title: 'Fecha Vencimiento', dataKey: 'fechaV' },
        { title: '01 - 30', dataKey: 'dias30' },
        { title: '31 - 60', dataKey: 'dias60' },
        { title: '61 - 90', dataKey: 'dias90' },
        { title: '91 o más', dataKey: 'dias91' },
        { title: 'Subtotal', dataKey: 'subTotal' },
        { title: 'Total', dataKey: 'total' }
      ]

      let contenido = []
      let acumTotal = 0
      let acum = 0
      let acumSubtotal = 0

      let acum30 = 0
      let acum60 = 0
      let acum90 = 0
      let acum91 = 0

      var doc = new Jspdf('l', 'pt')
      for (let i = 0; i < this.clientes.length; i++) {
        for (let j = 0; j < this.cxc.length; j++) {
          if (this.clientes[i]._id === this.cxc[j].idCliente._id) {
            acum += this.numberPDF(this.cxc[j].debito) - this.numberPDF(this.cxc[j].credito)
            let debi = parseFloat(this.cxc[j].debito)
            let fechaRe = this.formato2(this.cxc[j].fechaRegistro)
            let fechaVe = this.formato2(this.cxc[j].fechaVencimiento)
            let sub = this.numberPDF(this.cxc[j].idVenta.total)
            if (this.cxc[j].moroso === 0) {
              contenido.push({
                numF: this.cxc[j].numFactura,
                fechaR: fechaRe,
                fechaV: fechaVe,
                dias30: 0.00,
                dias60: 0.00,
                dias90: 0.00,
                dias91: 0.00,
                subTotal: sub,
                total: acum.toFixed(2)
              })
            } else if (this.cxc[j].moroso > 0 && this.cxc[j].moroso < 31) {
              contenido.push({
                numF: this.cxc[j].numFactura,
                fechaR: fechaRe,
                fechaV: fechaVe,
                dias30: debi.toFixed(2),
                dias60: 0.00,
                dias90: 0.00,
                dias91: 0.00,
                subTotal: sub,
                total: acum.toFixed(2)
              })
              this.numberPDF(debi)
              acum30 += debi
            } else if (this.cxc[j].moroso > 30 && this.cxc[j].moroso < 61) {
              contenido.push({
                numF: this.cxc[j].numFactura,
                fechaR: fechaRe,
                fechaV: fechaVe,
                dias30: 0.00,
                dias60: debi,
                dias90: 0.00,
                dias91: 0.00,
                subTotal: sub,
                total: acum.toFixed(2)
              })
              this.numberPDF(debi)
              acum60 += debi
            } else if (this.cxc[j].moroso > 60 && this.cxc[j].moroso < 91) {
              contenido.push({
                numF: this.cxc[j].numFactura,
                fechaR: fechaRe,
                fechaV: fechaVe,
                dias30: 0.00,
                dias60: 0.00,
                dias90: debi,
                dias91: 0.00,
                subTotal: sub,
                total: acum.toFixed(2)
              })
              this.numberPDF(debi)
              acum90 += debi
            } else if (this.cxc[j].moroso > 90) {
              contenido.push({
                numF: this.cxc[j].numFactura,
                fechaR: fechaRe,
                fechaV: fechaVe,
                dias30: 0.00,
                dias60: 0.00,
                dias90: 0.00,
                dias91: debi,
                subTotal: sub,
                total: acum.toFixed(2)
              })
              this.numberPDF(debi)
              acum91 += debi
            }
          }
        }

        let acumSub = 0
        for (let k = 0; k < contenido.length; k++) {
          const aSub = parseFloat(contenido[k].subTotal)
          this.numberPDF(aSub)
          acumSub += aSub
        }

        let head = [
          [
            { content: this.clientes[i].rif + '    ' + this.clientes[i].nombre, colSpan: 9, styles: { halign: 'left', fillColor: [255, 255, 255], lineWidth: 0 } }
          ],
          columns
        ]

        contenido.push({
          // numF: this.clientes[i].nombre,
          fechaV: 'Total Vencidas: ',
          dias30: acum30.toFixed(2),
          dias60: acum60.toFixed(2),
          dias90: acum90.toFixed(2),
          dias91: acum91.toFixed(2)
        })
        acumSubtotal += acumSub
        acumTotal += acum

        // doc.text(50, doc.autoTableEndPosY() + 35, this.clientes[i].nombre)

        doc.setFontSize(10)
        doc.text(610, 35, 'ANÁLISIS DE VENCIMIENTO')
        doc.setFontSize(8)
        doc.text(590, 40, '_______________________________________________')
        doc.text(590, 52, 'Moneda: Bs. Soberano, Factor: 1, Cliente: Todos, Detallado')
        doc.text(590, 57, '_______________________________________________')
        doc.text(590, 69, 'Fecha de Emisión: ' + date)

        doc.setFontSize(14)
        doc.text(80, 40, this.cxc[i].idEmpresa.nombre)

        if (contenido.length > 1) {
          doc.autoTable(columns, contenido, {
            theme: 'grid',
            margin: { top: 120 },
            styles: { lineWidth: 0, lineColor: 10, font: 'helvetica', fontStyle: 'bold', textColor: 20, fontSize: 8 },
            pageBreak: 'avoid',
            head: head,
            didParseCell: function (data) {
              var rows = data.table.body
              if (data.row.index === rows.length - 1) {
                if (data.column.dataKey === 'numF' || data.column.dataKey === 'fechaR' ||
                    data.column.dataKey === 'subTotal' || data.column.dataKey === 'total') {
                  data.cell.styles.fillColor = [255, 255, 255]
                }
                if (data.column.dataKey === 'fechaV' || data.column.dataKey === 'dias30' || data.column.dataKey === 'dias60' ||
                    data.column.dataKey === 'dias90' || data.column.dataKey === 'dias91') {
                  data.cell.styles.lineWidth = 1
                }
              }
              if (data.row.index === rows.length - 2 && data.column.dataKey === 'total') {
                data.cell.styles.lineWidth = 1
              }
            },
            headStyles: { fillColor: [255, 255, 255], lineWidth: 1 }
            // startY: doc.autoTableEndPosY() + 40
          })
        }

        acum30 = 0
        acum60 = 0
        acum90 = 0
        acum91 = 0
        acum = 0
        contenido = []
      }

      contenido.push({
        numF: 'TOTAL GENERAL',
        subTotal: acumSubtotal.toFixed(2),
        total: acumTotal.toFixed(2)
      })
      doc.autoTable(columns, contenido, {
        theme: 'plain',
        margin: { top: 90 },
        styles: { lineWidth: 0, lineColor: 10, fillColor: [192, 192, 192], font: 'helvetica', fontStyle: 'bold', textColor: 20, fontSize: 8 },
        showHead: 'never'
        // pageBreak: 'avoid'
      })

      doc.setProperties({
        title: 'Factura'
      })
      doc.output('dataurlnewwindow')
    },

    initialize () {
      this.listarCuentasXCobrar()
    },
    // validarCrear(){
    //   return this.permisosRuta.accion.includes('Crear')
    // },

    // validarModificar(){
    //   return this.permisosRuta.accion.includes('Modificar')
    // },

    // validarEliminar(){
    //   return this.permisosRuta.accion.includes('Eliminar')
    // },

    formato (fecha) {
      return fecha.substr(0, 10)
    },

    formato2 (fecha) {
      return this.$moment(fecha).format('DD-MM-YYYY')
    },

    decimal (val) {
      return Number.parseFloat(val).toFixed(2)
    },

    listarCuentasXCobrar () {
      Api.get('cuentaporcobrar')
        .then(response => {
          this.cxc = response.data
          this.clientesCXC(response.data)
          let hoy = new Date()
          let moroso
          this.cxc.map((data, i) => {
            if (data.debito === 0) {
              this.cxc[i].estatusPago = 'Cancelada'
            } else {
              this.cxc[i].estatusPago = 'Pendiente'
            }
            data.fechaRegistro = this.formato(data.fechaRegistro)
            data.fechaVencimiento = this.formato(data.fechaVencimiento)
            data.fechaCierreFactura = this.formato(data.fechaCierreFactura)
            let fecha = this.$moment(hoy)
            let fecha2 = this.$moment(data.fechaVencimiento)
            moroso = fecha.diff(fecha2, 'days')
            if (moroso <= 0) this.cxc[i].moroso = 0
            else this.cxc[i].moroso = moroso
            data.debito = this.decimal(data.debito)
            data.credito = this.decimal(data.credito)
          })
          this.loading = false
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar',
             // text: 'Por favor, verifique los datos e intente de nuevo'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message);
          }
        })
    },

    clientesCXC (cxc) {
      cxc.map(data => {
        if (this.clientes.length === 0) {
          this.clientes.push(data.idCliente)
        } else {
          let bool = false
          for (let i = 0; i < this.clientes.length; i++) {
            if (data.idCliente._id !== this.clientes[i]._id) {
              bool = true
            } else {
              bool = false
              break
            }
          }
          if (bool) {
            this.clientes.push(data.idCliente)
          }
        }
      })
    },

    numberPDF (num) {
      return Number.parseFloat(num).toFixed(2)
    },

    editItem (item) {
      this.editedIndex = this.cxc.indexOf(item)
      this.form = Object.assign({}, item)
      this.dialog = true
    },
    deleteItem (item) {
      const index = this.cxc.indexOf(item)
      this.$swal({
        icon: 'warning',
        title: '¿Seguro que quiere borrar?',
        text: 'No podrá revertir',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, borrar',
        cancelButtonText: 'cancelar'
      }).then(result => {
        if (result.value) {
          this.$swal('Borrado!', 'Su registro fue borrado.', 'success')
          this.cxc.splice(index, 1)
          Api.put('/cxc/deletelog/' + item._id).then(response => {
            console.log(response)
          })
        }
      })
    },
    close () {
      this.dialog = false
      setTimeout(() => {
        this.form = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    permissDenied (status) {
      if (status === '403') {
        this.$swal({
          icon: 'error',
          title: 'Permiso denegado',
          text: 'No tiene pemisos suficientes para ver esta página',
          allowOutsideClick: false,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'ok',
          onAfterClose: () => {
            window.location.href = '/home'
          }
        })
      }
    }

  }
}
</script>
